export const DOMAIN_CONFIGS = {
  ops: {
    domain: 'ops',
    accentColor: '#7aa2f7',
    label: 'OPS',
    rootPaths: ['/opt/stacks/', '/home/nsa/projects/', '/home/nsa/scripts/'],
    docCategories: ['Configs', 'Logs', 'Scripts', 'Backups'],
    nodeFilter: ['container', 'server'],
    specificTabs: ['Containers'],
    explorerContexts: [
      { name: 'Nginx', roots: ['/etc/nginx/sites-available/'] },
      { name: 'Stacks', roots: ['/opt/stacks/data/', '/opt/stacks/job-tracker/'] },
      { name: 'Scripts', roots: ['/home/nsa/scripts/'] },
      { name: 'Logs', roots: ['/home/nsa/backups/'] },
    ],
  },
  sec: {
    domain: 'sec',
    accentColor: '#f7768e',
    label: 'SEC',
    rootPaths: ['/opt/stacks/', '/home/nsa/scripts/'],
    docCategories: ['Configs', 'Certs', 'Logs'],
    nodeFilter: ['container', 'server'],
    specificTabs: ['Zugang'],
    explorerContexts: [
      { name: 'UFW', roots: ['/home/nsa/scripts/'] },
      { name: 'Stacks', roots: ['/opt/stacks/'] },
    ],
  },
  crm: {
    domain: 'crm',
    accentColor: '#e0af68',
    label: 'CRM',
    rootPaths: ['/home/nsa/projects/', '/opt/stacks/'],
    docCategories: ['Vertraege', 'Angebote', 'Rechnungen'],
    nodeFilter: ['container'],
    specificTabs: ['Clients'],
    explorerContexts: [
      { name: 'Clients', roots: ['/home/nsa/projects/devbox-clients/'] },
      { name: 'Vorlagen', roots: ['/home/nsa/projects/devbox-clients/'] },
    ],
  },
  comm: {
    domain: 'comm',
    accentColor: '#bb9af7',
    label: 'COMM',
    rootPaths: ['/home/nsa/projects/', '/opt/stacks/'],
    docCategories: ['Configs', 'Logs'],
    nodeFilter: ['container'],
    specificTabs: ['Messages'],
    explorerContexts: [
      { name: 'Matrix', roots: ['/opt/stacks/matrix/'] },
      { name: 'Ntfy', roots: ['/opt/stacks/ntfy/'] },
    ],
  },
  dev: {
    domain: 'dev',
    accentColor: '#9ece6a',
    label: 'DEV',
    rootPaths: ['/home/nsa/projects/', '/opt/stacks/', '/home/nsa/scripts/'],
    docCategories: ['README', 'API Docs', 'Configs'],
    nodeFilter: ['container', 'server'],
    specificTabs: ['Repos'],
    explorerContexts: [
      { name: 'Projects', roots: ['/home/nsa/projects/devbox-ecosystem/'] },
      { name: 'Scripts', roots: ['/home/nsa/scripts/'] },
      { name: 'Stacks', roots: ['/opt/stacks/'] },
    ],
  },
  projects: {
    domain: 'projects',
    accentColor: '#73daca',
    label: 'PROJECTS',
    rootPaths: ['/home/nsa/projects/'],
    docCategories: ['Specs', 'Roadmaps', 'Status'],
    nodeFilter: ['container'],
    specificTabs: ['Tasks'],
    explorerContexts: [
      { name: 'Context', roots: ['/home/nsa/projects/devbox-ecosystem/context/'] },
      { name: 'Repos', roots: ['/home/nsa/projects/'] },
    ],
  },
  wiki: {
    domain: 'wiki',
    accentColor: '#73daca',
    label: 'WIKI',
    rootPaths: ['/home/nsa/projects/', '/home/nsa/projects/devbox-ecosystem/docs/'],
    docCategories: ['Dokumentation', 'Notizen', 'Vorlagen'],
    nodeFilter: ['container'],
    specificTabs: ['Artikel'],
    explorerContexts: [
      { name: 'Wiki', roots: ['/home/nsa/projects/devbox-ecosystem/context/', '/home/nsa/projects/devbox-ecosystem/docs/'] },
      { name: 'Notes', roots: ['/home/nsa/projects/silverbullet/space/'] },
      { name: 'MkDocs', roots: ['/home/nsa/mkdocs/docs/'] },
    ],
  },
  media: {
    domain: 'media',
    accentColor: '#ff9e64',
    label: 'MEDIA',
    rootPaths: ['/home/nsa/projects/', '/home/nsa/nextcloud/'],
    docCategories: ['Videos', 'Fotos', 'Musik'],
    nodeFilter: ['container'],
    specificTabs: ['Library'],
    explorerContexts: [
      { name: 'Nextcloud', roots: ['/home/nsa/nextcloud/'] },
      { name: 'Projects', roots: ['/home/nsa/projects/devbox-ecosystem/'] },
    ],
  },
  home: {
    domain: 'home',
    accentColor: '#f7768e',
    label: 'HOME',
    rootPaths: ['/home/nsa/projects/', '/opt/stacks/'],
    docCategories: ['Configs', 'Netzwerk'],
    nodeFilter: ['device', 'server'],
    specificTabs: ['Network'],
    explorerContexts: [
      { name: 'Config', roots: ['/opt/stacks/'] },
      { name: 'Scripts', roots: ['/home/nsa/scripts/'] },
    ],
  },
  creative: {
    domain: 'creative',
    accentColor: '#ff9e64',
    label: 'CREATIVE',
    rootPaths: ['/home/nsa/projects/', '/home/nsa/nextcloud/'],
    docCategories: ['Assets', 'Designs', 'Praesentationen'],
    nodeFilter: ['container'],
    specificTabs: ['Studio'],
    explorerContexts: [
      { name: 'Assets', roots: ['/home/nsa/nextcloud/'] },
      { name: 'Projects', roots: ['/home/nsa/projects/devbox-ecosystem/'] },
    ],
  },
  private: {
    domain: 'private',
    accentColor: '#c0caf5',
    label: 'PRIVATE',
    rootPaths: ['/home/nsa/projects/', '/home/nsa/scripts/'],
    docCategories: ['Journal', 'Notizen', 'Dokumente'],
    nodeFilter: ['server', 'device'],
    specificTabs: ['Intel', 'Jobs'],
    explorerContexts: [
      { name: 'Journal', roots: ['/home/nsa/projects/devbox-ecosystem/context/sessions/'] },
      { name: 'OKRs', roots: ['/home/nsa/projects/devbox-ecosystem/context/projects/'] },
    ],
  },
  data: {
    domain: 'data',
    accentColor: '#2ac3de',
    label: 'DATA',
    rootPaths: ['/home/nsa/projects/', '/opt/stacks/', '/home/nsa/scripts/'],
    docCategories: ['Schemas', 'Queries', 'Configs'],
    nodeFilter: ['container', 'server'],
    specificTabs: ['Databases', 'Flows', 'ML'],
    explorerContexts: [
      { name: 'Backend', roots: ['/opt/stacks/data/backend/'] },
      { name: 'Scripts', roots: ['/home/nsa/scripts/'] },
      { name: 'Backups', roots: ['/home/nsa/backups/'] },
    ],
  },
  admin: {
    domain: 'admin',
    accentColor: '#f7768e',
    label: 'ADMIN',
    rootPaths: ['/home/nsa/projects/', '/opt/stacks/', '/home/nsa/scripts/', '/home/nsa/backups/'],
    docCategories: ['Configs', 'Logs', 'Users', 'Billing'],
    nodeFilter: ['container', 'server', 'device'],
    specificTabs: ['Users', 'Billing', 'System'],
    explorerContexts: [
      { name: 'Stacks', roots: ['/opt/stacks/'] },
      { name: 'Scripts', roots: ['/home/nsa/scripts/'] },
      { name: 'Backups', roots: ['/home/nsa/backups/'] },
      { name: 'Logs', roots: ['/home/nsa/backups/'] },
    ],
  },
  apps: {
    domain: 'apps',
    accentColor: '#9ece6a',
    label: 'APPS',
    rootPaths: ['/opt/stacks/', '/home/nsa/projects/'],
    docCategories: ['Configs', 'Logs', 'Stacks'],
    nodeFilter: ['container'],
    specificTabs: ['Registry', 'Deploy'],
    explorerContexts: [
      { name: 'Stacks', roots: ['/opt/stacks/'] },
      { name: 'Config', roots: ['/home/nsa/projects/devbox-ecosystem/'] },
    ],
  },
  master: {
    domain: 'master',
    accentColor: '#c0caf5',
    label: 'MASTER',
    rootPaths: ['/home/nsa/projects/', '/opt/stacks/'],
    docCategories: ['Architektur', 'Status', 'Berichte'],
    nodeFilter: ['container', 'server', 'device'],
    specificTabs: ['Overview'],
    explorerContexts: [
      { name: 'Infra', roots: ['/home/nsa/projects/devbox-ecosystem/context/infra/'] },
      { name: 'Context', roots: ['/home/nsa/projects/devbox-ecosystem/context/'] },
      { name: 'Logs', roots: ['/home/nsa/backups/'] },
    ],
  },
  ai: {
    domain: 'ai',
    accentColor: '#bb9af7',
    label: 'AI',
    rootPaths: ['/home/nsa/projects/devbox-ecosystem/', '/opt/stacks/data/backend/', '/home/nsa/scripts/'],
    docCategories: ['Agents', 'Models', 'Prompts', 'Workflows'],
    nodeFilter: ['container'],
    specificTabs: ['Models', 'Agents'],
    explorerContexts: [
      { name: 'Agency', roots: ['/opt/stacks/data/backend/routers/'] },
      { name: 'AI Views', roots: ['/home/nsa/projects/devbox-ecosystem/ai/src/views/'] },
      { name: 'Shared KI', roots: ['/home/nsa/projects/devbox-ecosystem/shared/components/'] },
      { name: 'Scripts', roots: ['/home/nsa/scripts/'] },
      { name: 'Prompts', roots: ['/home/nsa/projects/devbox-ecosystem/prompts/'] },
    ],
  },
  finance: {
    domain: 'finance',
    accentColor: '#9ece6a',
    label: 'FINANCE',
    rootPaths: ['/home/nsa/projects/finance-terminal/'],
    docCategories: ['Analyse', 'Reports', 'Strategien'],
    nodeFilter: ['container'],
    specificTabs: ['Portfolio', 'Signale'],
    explorerContexts: [
      { name: 'Backend', roots: ['/home/nsa/projects/finance-terminal/backend/'] },
      { name: 'Config', roots: ['/home/nsa/projects/finance-terminal/'] },
    ],
  },
};

/* ── SubTab definitions per domain + section ── */
export const SUB_TABS = {
  ops: {
    explorer: [
      { label: 'Dateien', path: '/explorer' },
      { label: 'Editor', path: '/explorer/editor' },
      { label: 'Dokumente', path: '/explorer/docs' },
    ],
    nodes: [
      { label: 'Container', path: '/nodes' },
      { label: 'Server', path: '/nodes/server' },
    ],
  },
  sec: {
    explorer: [
      { label: 'Dateien', path: '/explorer' },
      { label: 'Configs', path: '/explorer/configs' },
    ],
  },
  dev: {
    explorer: [
      { label: 'Dateien', path: '/explorer' },
      { label: 'Editor', path: '/explorer/editor' },
      { label: 'Repos', path: '/explorer/repos' },
    ],
  },
  data: {
    explorer: [
      { label: 'Dateien', path: '/explorer' },
      { label: 'Editor', path: '/explorer/editor' },
      { label: 'Dokumente', path: '/explorer/docs' },
    ],
    nodes: [
      { label: 'Container', path: '/nodes' },
      { label: 'Databases', path: '/nodes/db' },
    ],
  },
  master: {
    explorer: [
      { label: 'Dateien', path: '/explorer' },
      { label: 'Editor', path: '/explorer/editor' },
      { label: 'Dokumente', path: '/explorer/docs' },
    ],
    graph: [
      { label: 'Service-Map', path: '/graph' },
      { label: 'Domain-Flow', path: '/graph/flow' },
      { label: 'Impact-Analyse', path: '/graph/impact' },
    ],
  },
};

export function getSubTabs(domain, section) {
  return SUB_TABS[domain]?.[section] || [];
}

export function getDomainConfig(domain) {
  return DOMAIN_CONFIGS[domain] || DOMAIN_CONFIGS.ops;
}

// DocBrain domain config
DOMAIN_CONFIGS.docbrain = {
  domain: 'docbrain',
  accentColor: '#bb9af7',
  label: 'DOCBRAIN',
  rootPaths: ['/home/nsa/projects/docbrain/'],
  docCategories: ['Vertraege', 'Berichte', 'Strategien', 'Sonstiges'],
  nodeFilter: ['container'],
  specificTabs: [],
  explorerContexts: [
    { name: 'Backend', roots: ['/home/nsa/projects/docbrain/backend/'] },
    { name: 'Data', roots: ['/home/nsa/projects/docbrain/'] },
  ],
};
